import zhCn from 'element-plus/dist/locale/zh-cn.mjs';
import en from 'element-plus/dist/locale/en.mjs';
import ja from 'element-plus/dist/locale/ja.mjs';
import { provideGlobalConfig } from 'element-plus/es';
import AppConfig from '@/settings.js';
//转换element中文组件
export function transZhCnElemenComponent(component) {
  return defineComponent({
    setup: function setup() {
      provideGlobalConfig({
        locale: getLangByLocale(AppConfig.locale)
      });
    },
    render: function render() {
      return h(component);
    }
  });
}
export function getLangByLocale(locale) {
  switch (locale) {
    case 'zh-cn':
      return zhCn;
    case 'en':
      return en;
    case 'ja':
      return ja;
    default:
      return zhCn;
  }
}